import { render, staticRenderFns } from "./plugin-importer.vue?vue&type=template&id=3cfd26dc&scoped=true"
import script from "./plugin-importer.vue?vue&type=script&lang=js"
export * from "./plugin-importer.vue?vue&type=script&lang=js"
import style0 from "./plugin-importer.vue?vue&type=style&index=0&id=3cfd26dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd26dc",
  null
  
)

export default component.exports